export class VendorStatusReq{
    id:number;
    status:string;
    remarks:string;
}